<template>
    <div class="row g-1">
        <div class="col-12 col-md-5 mb-1 mb-md-0">
            <input class="form-control" v-model="currentQuery" :placeholder="$t('search.placeholder')">
        </div>
        <div class="col-12 col-md-5 mb-1 mb-md-0">
            <select class="form-select" v-model="currentDate">
                <option :value="null">{{ $t('search.all') }}</option>
                <option v-for="single in dates" :key="single" :value="single">{{ single }}</option>
            </select>
        </div>
        <div class="col-12 col-md-1 mb-1 mb-md-0 text-end">
            <input class="btn btn-primary w-100" type="button" :value="$t('search.buttons.search')" @click.prevent="onSearch">
        </div>
        <div class="col-12 col-md-1 mb-1 mb-md-0 text-end">
            <input class="btn btn-secondary w-100" type="button" :value="$t('search.buttons.reset')" @click.prevent="onReset">
        </div>
    </div>
</template>

<script>
import { router } from "@inertiajs/vue3";

export default {
    name: "SearchWithDate",
    props: {
        url: {
            type: String,
            required: true
        },
        query: {
            type: String
        },
        date: {
            type: String,
        },
        dates: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            currentQuery: null,
            currentDate: this.date
        }
    },
    computed:{
        isQueryEmpty(){
            return Boolean(this.query === '' || this.query === null)
        }
    },
    methods: {
        onSearch(){
            router.get(this.url, {
                query: this.currentQuery,
                date: this.currentDate
            }, {
                only: ['list', 'query', 'page', 'date']
            });
        },
        onReset(){
            router.get(this.url, {
                query: null,
                date: null
            }, {
                only: ['list', 'query', 'page', 'date']
            });
        }
    },
    mounted() {
        this.currentQuery = this.query;
    },
    update() {
        this.currentQuery = this.query;
    }
}
</script>

<style scoped>

</style>
